import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import LOGO_WHITE from '../logo-white.svg';
import LogoutButton from './LogoutButton';
import SidebarMenuItem from './SidebarMenuItem';
import COMPANY_STUB_LOGO from '../company_icon.png';
import LanguageSelector from './LanguageSelector';
import Localization from '../utils/localization';
import { withTranslation } from 'react-i18next';
import { appConfig } from '../config/appConfig';

class SidebarComponent extends React.Component {
    replaceBrokenImageSrc(event) {
        const companyLogo = event.target;
        companyLogo.setAttribute('src', COMPANY_STUB_LOGO);
    }

    sidebarItems() {
        const { t } = this.props;
        const items = [    
            ...(appConfig.metaBase
            ? [{
                path: '/dashboard',
                icon: 'fa fa-users',
                title: 'Overview',
                key: 'Overview'
                }]
            : []),
            ...(appConfig.requestsEnabled
            ? [{
                path: '/dashboard/requests',
                icon: 'fa fa-paper-plane',
                title: t('sidebar.requests'),
                key: 'Requests'
                }]
            : []),
            ...(appConfig.policiesEnabled
            ? [{
                path: '/dashboard/policies',
                icon: 'fa fa-shield',
                title: t('sidebar.policies'),
                key: 'Policies'
                }]
            : []),
            {
                path: '/dashboard/staff',
                icon: 'fa fa-users',
                title: t('sidebar.employees'),
                key: 'Employees'
            },
            {
                path: '/dashboard/invoices',
                icon: 'fa fa-file-text',
                title: t('sidebar.invoices'),
                key: 'Invoices'
            },
            {
                path: '/dashboard/profile',
                icon: 'fa fa-user',
                title: t('sidebar.profile'),
                key: 'Profile'
            }
            // {
            //     path: '/dashboard/plan-purchase',
            //     icon: 'fa fa-credit-card',
            //     title: t("sidebar.planPurchase"),
            //     key: "Plan Purchase"
            // },
        ];

        return items;
    }

    render() {
        const { showSideBar, companyName, companyLogo, invoices, userType, isFetching, t } =
            this.props;

        return (
            <div id="left" className={`column sidebar ${showSideBar ? '' : 'sidebar__active'}`}>
                {Localization.enableLanguageOptions() && <LanguageSelector />}
                <div className="top-left relative-position">
                    <Link to="/dashboard/profile" style={{ textDecoration: 'none' }}>
                        <div className="sidebar__top">
                            <img
                                src={companyLogo || COMPANY_STUB_LOGO}
                                alt={t('sidebar.companyImageAltText')}
                                onError={this.replaceBrokenImageSrc}
                            />
                            <p>{companyName.toUpperCase()}</p>
                        </div>
                    </Link>
                </div>
                <div className="bottom">
                    <nav>
                        <ul>
                            {this.sidebarItems().map((item, i) => {
                                if (userType === 'SME' && invoices.length === 0) {
                                    if ((item.key !== 'Plan Purchase' && item.key !== 'Requests') || isFetching) {
                                        return null;
                                    }
                                    return (
                                        <SidebarMenuItem
                                            key={i}
                                            to={item.path}
                                            icon={item.icon}
                                            title={item.title}
                                        />
                                    );
                                }

                                if (
                                    userType === 'SME' &&
                                    invoices.findIndex(
                                        (invoice) => invoice.active_status_id === 1
                                    ) >= 0
                                ) {
                                    if (item.key === 'Plan Purchase') {
                                        return null;
                                    }
                                    return (
                                        <SidebarMenuItem
                                            key={i}
                                            to={item.path}
                                            icon={item.icon}
                                            title={item.title}
                                        />
                                    );
                                }

                                if (userType !== 'SME') {
                                    if (item.key === 'Plan Purchase') return null;
                                    return (
                                        <SidebarMenuItem
                                            key={i}
                                            to={item.path}
                                            icon={item.icon}
                                            title={item.title}
                                        />
                                    );
                                }
                            })}
                            <SidebarMenuItem
                                key="help"
                                to="/dashboard/help"
                                icon="fa fa-question-circle"
                                title={t('sidebar.help')}
                            />

                            <LogoutButton title={t('sidebar.logout')} icon="fa fa-sign-out" />
                        </ul>
                    </nav>
                </div>
                <div className="bottom bottom-left" style={{ borderTop: 'none' }}>
                    <img
                        src={`/img/${appConfig.logoName}.svg`}
                        alt={t('common.imageLogoAltText', { companyName: appConfig.companyName })}
                        style={{ width: '100%' }}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { invoice, display } = state;
    const { showSideBar } = display || {};
    const { invoices, isFetching } = invoice;
    return { showSideBar, invoices, isFetching };
}

const SidebarComponentWithTranslation = withTranslation()(SidebarComponent);
export default withRouter(connect(mapStateToProps)(SidebarComponentWithTranslation));
